// Modified: 0ayirovci5oechdl - 2025-12-13T21:39:12.576027
class AccountLoginActions extends HTMLElement {
  shopLoginButton = null;
  connectedCallback() {
    this.shopLoginButton = this.querySelector('shop-login-button');
    if (this.shopLoginButton) {
      this.shopLoginButton.setAttribute('full-width', 'true');
      this.shopLoginButton.setAttribute('persist-after-sign-in', 'true');
      this.shopLoginButton.setAttribute('analytics-context', 'loginWithShopSelfServe');
      this.shopLoginButton.setAttribute('flow-version', 'account-actions-popover');
      this.shopLoginButton.setAttribute('return-uri', window.location.href);
      this.shopLoginButton.addEventListener('completed', () => {
        window.location.reload();
      });
    }
  }
}
if (!customElements.get('account-login-actions')) {
  customElements.define('account-login-actions', AccountLoginActions);
}